import styled from 'styled-components';

export const ActionButton = styled.button`
  border: 0;
  cursor: pointer;
  background: transparent;
  padding: 0.5rem;
  display: flex;
  align-items: center;
`;
